<script setup lang="ts">
definePageMeta({
  name: 'repealed',
  layout: false,
  theme: 'blurple',
  colorMode: 'light',
})

useSeoMeta({
  title: 'Opphevet',
  description: 'Den gamle versjonen av Juridika har blitt stengt.',
})

useHead({
  bodyAttrs: {
    class: 'bg-white',
  },
})
</script>

<template>
  <LayoutContainer>
    <Header />
    <ContentDiv is="main" class="flex-1 flex items-center text-center justify-center">
      <div class="w-full max-w-[780px] mx-auto px-m">
        <div class="flex flex-col gap-2xs items-center text-center justify-center">
          <div class="flex flex-col gap-2xs">
            <h2 class="text-4xl sm:text-6xl font-heading font-light text-primary text-center">
              Etter en lengre overgangsfase har vi nå stengt den gamle versjonen av Juridika.
            </h2>
          </div>
          <p class="mt-l text-xl sm:text-2xl font-body font-light text-primary text-center">
            Ved spørsmål, ta kontakt med <NuxtLink class="text-xl sm:text-2xl font-body font-light text-primary" :to="{ name: 'info-page', params: { slug: 'kundeservice' } }">kundeservice</NuxtLink>.
          </p>
        </div>
      </div>
    </ContentDiv>
  </LayoutContainer>
</template>
